module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAABAA4DAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAACAr/xAAfEAAAAwkAAAAAAAAAAAAAAAAAAQIDBQcyNHFyscL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AsrhrIxunkAr3RTJxLRAP/9k="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left-border.jpg
// module id = 311
// module chunks = 5